import qs from "qs";
import Axios from "axios";

export class Report {
  constructor(apiUrl, headers) {
    // Set report API URL
    this.reportUrl = `${apiUrl}/report`;
    
    this.headers = headers;
  }

  async getGiftBoxReports(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true, indices: false
    });

    const url = `${this.reportUrl}/morning-coin/gift-boxes${queryString}`;

    const response = await Axios.get(
      url, { headers: this.headers }
    );

    return response;
  }

  async downloadGiftBoxReports(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true, indices: false
    });

    const url = `${this.reportUrl}/morning-coin/gift-boxes/download${queryString}`;

    const _headers = {
      ...this.headers,
      Accept: "application/octet-stream",
    };

    const response = await Axios.get(
      url, { headers: _headers, responseType: "blob" }
    );

    return response;
  }

  async getMncEvents() {
    const url = `${this.reportUrl}/morning-coin/mnc-events`;

    const response = await Axios.get(
      url, { headers: this.headers }
    );

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BackendAdminClient/report.js